<template>
  <div class="home-org-list">
    <action-bar>
      <search placeholder="请输入组织名称" @onSearch="onSearch"></search>
      <el-button type="primary" @click="handleToHomeChart()">首页大屏</el-button>
      <div class="fill"></div>
      <subscribe-block></subscribe-block>
    </action-bar>
    <common-bg-plate>
      <card-table
        :item-meta-title="metaTitle"
        :item-meta-data="metaData"
        :table-data="list"
        :paging="paging"
        @pagination="handleSizeOrPageChange"
      >
      </card-table>
    </common-bg-plate>
  </div>
</template>

<script>
import subscribeBlock from '../components/subscribeBlock'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Organization',
  components: {
    subscribeBlock
  },
  data() {
    return {
      metaTitle: {
        label: '组织id',
        value: 'OrgId'
      },
      metaData: [
        { label: '组织名称', value: 'OrgName' },
        { label: '节点数', value: 'NodeNum' }
      ],
      labelList: [
        { label: '组织id', value: 'OrgId' },
        { label: '组织名称', value: 'OrgName' },
        { label: '节点数', value: 'NodeNum' }
      ],
      list: [],
      paging: {
        offset: 0,
        limit: 10,
        total: 0
      }
    }
  },
  watch: {
    '$store.state.home.chainCid': {
      deep: true,
      handler() {
        this.getListFn()
      }
    }
  },
  mounted() {
    if (this.$store.state.home.chainCid) {
      this.getListFn()
    }
  },
  methods: {
    ...mapActions(['getChainOrgLists']),
    getListFn(params = {}) {
      params.offset = params.offset || this.paging.offset
      params.limit = params.limit || this.paging.limit
      params.chainId = this.$store.state.home.chainCid

      this.getChainOrgLists({ ...params }).then(res => {
        this.list = res?.items
        this.paging.limit = res.limit
        this.paging.total = res.total
        this.paging.offset = res.offset
      })
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getListFn({ offset: offset * limit, limit: limit })
    },
    onSearch(val) {
      this.getListFn({ name: val })
    },
    handleToHomeChart() {
      this.$router.push('../dataAnalysis')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('home-org-list', (), ());
.home-org-list {
  @include adaptation(
    (
      --home-org-list-search-width: 253px,
      --home-org-list-offset: 48px
    )
  );
  --home-org-list-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--home-org-list-offset)
  );
  .cbaas-search-wrap {
    width: var(--home-org-list-search-width);
  }

  .common-bg-plate {
    background: none;
    border: none;

    .card-table-wrap {
      height: 100%;
      min-height: var(--home-org-list-min-height);

      /deep/ {
        .el-empty {
          height: 100%;
          min-height: var(--home-org-list-min-height);
        }

        .card-table {
          height: 100%;
          min-height: var(--home-org-list-min-height);
        }
      }
    }
  }
}
</style>
